import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CourseService } from "src/app/services/api/courses.service";
import { ToastService } from "src/app/services/toast-service/toast.service";
import { SharedModule } from "src/shared/shared.module";

@Component({
  selector: "app-active-student-course",
  imports: [CommonModule, TranslateModule, SharedModule],
  templateUrl: "./active-student-course.component.html",
  styleUrl: "./active-student-course.component.scss",
})
export class ActiveStudentCourseComponent {
  data = inject(MAT_DIALOG_DATA);
  #dialogRef = inject(MatDialogRef<ActiveStudentCourseComponent>);
  #courseService = inject(CourseService);
  #toastService = inject(ToastService);
  #translate = inject(TranslateService);

  constructor() {}

  onClose(): void {
    this.#dialogRef.close();
  }

  onConfirm(): void {
    // Logic to confirm the action can be added here if needed
    this.#courseService.activateCourse(this.data.course.id).subscribe({
      next: (response) => {
        // Optionally, close the dialog and pass back some data
        this.#dialogRef.close(response);
      },
      error: (error) => {
        this.#toastService.toastError(
          this.#translate.instant("VALIDATOR.SOMETHING_ERROR") +
            ": " +
            error.error.errors
        );
      },
    });
  }
}
